<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<a *ngIf="!href" [routerLink]="internalLink" [attr.title]="title" [tabindex]="tabindex" [ngClass]="builtClasses">
  <ng-template *ngTemplateOutlet="content"></ng-template>
</a>

<a *ngIf="href" [href]="href" [target]="target" [attr.title]="title" [tabindex]="tabindex" [ngClass]="builtClasses">
  <ng-template *ngTemplateOutlet="content"></ng-template>
</a>
